import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, DatePicker, Divider, Icon, Input, message, Modal, Row, Select } from 'antd';
import TableCommon from '../../components/common/table/TableCommon';
import { currencyVND, dateToString } from '../../utils';
import * as CommonService from '../../services/CommonService';
import { INVOICE_REFUND_ENDPOINT } from '../../services/endpoint';
import './style.scss';
import { useHistory } from 'react-router-dom';
import SelectRefundModal from './SelectRefundModal';

const { Option } = Select;

const DEFAULT_PAGE = {
	currentPage: 1,
	perpage: 20
};

export default () => {

	const [ds, setDs] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [loadingModal, setLoadingModal] = useState(false);
	const [searchValues, setSearchValues] = useState({});
	const [page, setPage] = useState({
		...DEFAULT_PAGE,
		total: 0
	});

	const history = useHistory();

	useEffect(() => {
		window.setLoading(true);
		CommonService.get(INVOICE_REFUND_ENDPOINT, {
			page: page.currentPage - 1,
			size: page.perpage
		}).then(res => {
			setDs(res.data?.contents);
			setPage({ ...page, total: res.data?.totalElements });
		}).catch(error => {
			message.error(error?.data?.message);
		}).finally(() => window.setLoading(false));
	}, []);

	const onSearch = async (pageParam = DEFAULT_PAGE) => {
		const param = { ...searchValues, page: pageParam.currentPage - 1, size: pageParam.perpage };
		window.setLoading(true);
		const resp = await CommonService.get(INVOICE_REFUND_ENDPOINT, param);
		setDs(resp.data?.contents);
		setPage({
			total: resp.data?.totalElements,
			...pageParam
		});
		window.setLoading(false);
	};

	const columns = [
		{
			title: 'STT',
			dataIndex: 'index',
			width: 60,
			align: 'center',
			render: (text, record, index) => (page.currentPage - 1) * page.perpage + index + 1
		},
		{
			title: 'Mã đơn trả hàng',
			dataIndex: 'invoiceRefundCode',
			align: 'center',
			width: 100,
			render: (text, record) => {
				return <Button style={{ padding: '0', textWrap: 'wrap' }} type={'link'}
											 onClick={() => history.push('/customer-refund/' + record.invoiceRefundId)}>{text}</Button>;
			}
		},
		{
			title: 'Mã đơn hàng',
			dataIndex: 'invoiceCode',
			width: 100,
			align: 'center',
			render: (text, record) => {
				return <Button style={{ padding: '0', textWrap: 'wrap' }} type={'link'}
											 onClick={() => history.push('/orders/' + record.invoiceId)}>{text}</Button>;
			}
		},
		{
			title: 'Mã đơn đổi hàng',
			dataIndex: 'invoiceExchangeCode',
			className: 'header-center-align',
			width: 100,
			render: (text, record) => {
				return <Button style={{ padding: '0', textWrap: 'wrap' }} type={'link'}
											 onClick={() => history.push('/orders/' + record.invoiceExchangeId)}>{text}</Button>;
			}
		},
		{
			title: 'Khách hàng',
			dataIndex: 'customerName',
			className: 'header-center-align',
			width: 200
		},
		// {
		// 	title: 'Trạng thái',
		// 	dataIndex: 'status',
		// 	align: 'center',
		// 	className: 'header-center-align',
		// 	width: 110,
		// 	render: (status) => {
		// 		const statusInfo = ORDER_STATUS.find(item => item.value === status);
		// 		return statusInfo ? <Tag color={statusInfo.color}>{statusInfo.name}</Tag> : null;
		// 	}
		// },
		{
			title: 'Tổng tiền',
			dataIndex: 'totalAmountRefund',
			width: 120,
			align: 'center',
			render: (el) => <>{currencyVND(el)}</>
		},
		{
			title: 'Ngày nhận hàng',
			dataIndex: 'createDate',
			width: 120,
			align: 'center',
			render: (el) => dateToString(el)
		},
		{
			title: 'Ghi chú',
			dataIndex: 'note',
			width: 120,
			align: 'center'
		}
	];

	const handleChange = (value, key) => {
		searchValues[key] = value;
		setSearchValues({ ...searchValues });
	};

	const onEnter = (evt) => {
		if (evt.key === 'Enter') {
			onSearch(DEFAULT_PAGE);
		}
	};


	return (<Fragment>
			<Row className="mb-10" id={'product__action'}>
				<Col style={{visibility: 'hidden'}}>
					<div>
						<Divider type="vertical" />
						<Icon type="download" />
						<span style={{ color: '#000000d9', margin: '0 5px' }} onClick={() => alert('Xuất file')}>Xuất file</span>
						<Divider type="vertical" />
						<Icon type="upload" />
						<span style={{ color: '#000000d9', margin: '0 5px' }} onClick={() => alert('Nhập file')}>Nhập file</span>
					</div>
				</Col>
				<Col>
					<Button type="primary" style={{ width: '180px' }} id={'btn-create-product'} icon="plus"
									onClick={() => setShowModal(true)}>Tạo đơn trả hàng</Button>
				</Col>
			</Row>
			<Row>
				<div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
					<Input
						style={{ height: '32px' }}
						placeholder="Tìm kiếm theo mã đơn hàng"
						allowClear
						onChange={(value) => handleChange(value.target.value, 'param')}
						onKeyDown={onEnter}
					/>
					<DatePicker.RangePicker
						allowClear
						placeholder={['Từ ngày', 'Đến ngày']}
						style={{ width: '500px' }}
						onChange={(value) => {
							const arr = value.map(el => dateToString(el));
							handleChange(arr[0], 'from');
							handleChange(arr[1], 'to');
						}} />
					<Button type="primary"
									style={{ width: '150px' }}
									onClick={() => onSearch(DEFAULT_PAGE)}>
						Tìm kiếm
					</Button>
				</div>
			</Row>
			<TableCommon bordered={true}
									 page={page}
									 setPage={setPage}
									 datasource={ds}
									 columns={columns}
									 onSearch={onSearch}
			/>
			<Modal title={'Chọn đơn để trả'} visible={showModal} className={'select-refund-modal'} onCancel={() => setShowModal(false)} footer={null}  width={1400}>
				<SelectRefundModal callback={() => setShowModal(false)} />
			</Modal>
		</Fragment>

	);
};
